import { useEffect, useRef, useState } from "react";
import { serverFetch } from "../../../server";
import { Button, Card, Checkbox, Input, message, Spin, Table, Typography } from "antd";
import { getUserToleName, hasSubstring } from "../../../extensions/helper";
import User from "./user";
import { useSelector } from "react-redux";
import { isMobile, menuSize } from "../../../extensions/design";

const { Text } = Typography;

const Users = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState();
  const [editName, setEditName] = useState();
  const [filter, setFilter] = useState({ showHidden: false, serchText: ""});
  const divRef = useRef(null);
  const user = useSelector((s) => s.user);

  const getData = () => {
    setLoading(true);
    serverFetch("user")
      .then(data => {
        setItems(data);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getData, []);

  const columns = [
    {title: "#", dataIndex: "id", width: 100 },
    {title: "Наименование", dataIndex: "name", minWidth: 200 },
    {title: "Должность", dataIndex: "position", minWidth: 200 },
    {title: "Роль", dataIndex: "role", render: getUserToleName},
    {title: "Акт.", dataIndex: "active", render: value => <Checkbox checked={value}/> },
    // {title: "Админ", dataIndex: "admin", render: value => <Checkbox checked={value}/> },
    {title: "Вход", dataIndex: "login", render: value => <Checkbox checked={value}/> },
    {title: "Почта", dataIndex: "email", minWidth: 200 },
    {title: "Календарь", dataIndex: "calendarName" },
    {title: "Карта", dataIndex: "card" },
    {title: "СКД", dataIndex: "skd", render: value => <Checkbox checked={value}/> },
  ]

  const onClose = (refresh) => {
    setEditId();
    setEditName();
    refresh && getData();
  }

  const onChangeFilter = value => setFilter({ ...filter, ...value });

  const filtered = items.filter(item => {
    if (!filter.showHidden && !item.active) return false;
    if (!hasSubstring(filter.serchText, item.name)) return false;
    return true;
  })

  const divItem = editId != null && <User id={editId} onClose={onClose} companyId={user?.companyId} userName={editName}/>
  const headerSize = divRef.current?.querySelector('.ant-table-thead')?.offsetHeight ?? 0;
  const tableHeight = divRef.current ? (document.documentElement.offsetHeight - headerSize - divRef.current.getBoundingClientRect().top - window.scrollY) : 0;
  const tableWidth = (document.documentElement.offsetWidth - divRef.current?.getBoundingClientRect().left) || 0;

  return !isMobile ? <div>
    <div className="sport-form-title">
      <Checkbox checked={filter.showHidden} onChange={e => onChangeFilter({ showHidden: e.target.checked })}>Показывать неактивные</Checkbox>
      <Input placeholder="Поиск" value={filter.serchText} onChange={e => onChangeFilter({serchText: e.target.value})} />
      <Button onClick={getData}>Обновить</Button>
      <Button onClick={() => setEditId(0)}>Новый</Button>
    </div>
    <div ref={divRef} style={{width: tableWidth}}>
      <Table
        dataSource={filtered}
        columns={columns}
        rowKey="id"
        loading={loading}
        size="small"
        pagination={false}
        scroll={{ y: tableHeight }}
        rowSelection={{ type: 'radio', selectedRowKeys: [editId], renderCell: checked => <div className={checked ? "list-indicator" : ""} /> }}
        onRow={(record) => ({onClick: () => {setEditId(record.id); setEditName(record.name);}})}
        tableLayout="auto"
      />
    </div>
    {divItem}
  </div> :
  <>
    <div className="col-one-title" style={{marginTop: "8px", marginBottom: "4px"}}>
      <Input placeholder="Поиск" value={filter.serchText} onChange={e => onChangeFilter({serchText: e.target.value})} allowClear/>
      <Button onClick={() => setEditId(0)}>Новый</Button>
    </div>
    {loading ? <Spin style={{margin: 16}}/> : (
      <div className="sale-cards-list" style={{height: window.innerHeight - menuSize - 65, overflowY: "scroll", overflowX: "clip"}}>
        {filtered.map(item => (
          <Card key={item.id} className="client-item-abon-card"
            onClick={() => { setEditId(item.id); setEditName(item.name); }}
            style={{ borderLeft: `4px solid ${item.active ? '#52c41a' : '#d9d9d9'}`, marginBottom: "6px" }}
          >
            <div className="sale-item-abon-card-name-debt-fields">
              <Text strong>{item.name}</Text>
              <Text style={{fontSize: "12px"}}>{getUserToleName(item.role)}</Text>
            </div>
            <div className="client-item-line-double-halfed">
              <Text>{item.position}</Text>
              <Text style={{fontSize: "12px", textAlign: "right"}}>{item.email}</Text>
            </div>
            <div style={{display: "flex", gap: 12, marginTop: 2}}>
              <Checkbox checked={item.login} disabled style={{fontSize: 12}}>Вход</Checkbox>
              <Checkbox checked={item.skd} disabled style={{fontSize: 12}}>СКД</Checkbox>
            </div>
          </Card>
        ))}
        {filtered.length === 0 && (
          <div style={{display: "flex", justifyContent: "center", width: "100%", marginBottom: 12}}>
            <Text>Нет данных</Text>
          </div>
        )}
      </div>
    )}
    {divItem}
  </>
}

export default Users;
